module.exports = __webpack_public_path__ + "static/img/background_top.e1cd500.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/timeLimitDeposit/background_top.png
// module id = WVzE
// module chunks = 0